import { render } from "./participateDBCMining.vue?vue&type=template&id=e15d6720&scoped=true"
import script from "./participateDBCMining.vue?vue&type=script&lang=js"
export * from "./participateDBCMining.vue?vue&type=script&lang=js"

import "./participateDBCMining.vue?vue&type=style&index=0&id=e15d6720&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e15d6720"]])

export default __exports__